import { RootState } from 'store/reducer';

export const notifications = (state: RootState): RootState['notifications'] => state.notifications;
